/**
 * Merchant archive/unarchive helpers.
 *
 * Archiving runs through the dedicated core-host endpoints
 * (`POST /api/v1/admin/merchants/:id/archive` and
 * `POST /api/v1/admin/merchants/:id/unarchive`), confirmed via the standard
 * promise dialog at the call site (the `clients/all` row action, moved
 * without its role gate — every row offers it).
 */

/** UI action from the merchants table row menu. */
export type MerchantArchiveAction = 'archive' | 'activate' | 'unarchive';

/** Wire endpoint suffix for `POST /api/v1/admin/merchants/:id/<suffix>`. */
export type MerchantArchiveEndpoint = 'archive' | 'unarchive';

/**
 * Archived merchants arrive via `status`; match loosely for variants such as
 * "archived"/"ARCHIVED" before choosing the restore action.
 */
export function isMerchantArchived(status?: string): boolean {
  return String(status ?? '')
    .toLowerCase()
    .includes('archiv');
}

/**
 * Maps the row action to the archive-endpoint suffix. `activate` is the
 * legacy restore action name — it hits `unarchive` like `unarchive` does.
 */
export function toMerchantArchiveEndpoint(
  action: MerchantArchiveAction = 'archive',
): MerchantArchiveEndpoint {
  return action === 'archive' ? 'archive' : 'unarchive';
}
